
import { Component, Prop, Vue } from 'vue-property-decorator'
import { FormatConstants } from '@/common/FormatConstants'
import { createAccordion } from '@/common/utils/CreateAccordion'
import CommonUtil from '@/common/utils/CommonUtil'
@Component({
  name: 'ContentTab1',
  components: {}
  })
export default class ContentTab1 extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  data!: Array<any>

  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  dataAccordion!: Array<any>

  private FormatConstants = FormatConstants

  /**
   * 画面要素描画後処理
   */
  mounted() {
    createAccordion()
  }

  /**
   * 元本確保型以外商品_商品情報(説明資料)リンク押下
   * @param pdfFilePath
   */
  private async openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }
}
